import { TPAComponentsProvider } from '@wix/wix-ui-tpa/cssVars';
import React, { useMemo } from 'react';
const Providers = _ref => {
  let {
    children,
    config
  } = _ref;
  const tpa = useMemo(() => ({
    mobile: config.isMobile,
    rtl: config.isRTL
  }), [config.isMobile, config.isRTL]);
  return /*#__PURE__*/React.createElement(TPAComponentsProvider, {
    value: tpa
  }, children);
};
export default Providers;
//# sourceMappingURL=providers.js.map